import React from 'react'
import ActorDetailForm from '../../formComponents/actorDetailForm'
import Actor from './Actor'

const Parties = (props) => {
  const {
    translate,
    actorDetailsAndActions,
    buyers,
    sellers,
    isNLAPP
  } = props

  // const actorDetailForm1 = (params) => {
    
  // }
  const actorDetailForm = (params) => {
    return <ActorDetailForm
      repKey='formOfRepresentation'
      eoriKey={isNLAPP ? 'eoriNo' :'externalIdentification'}
      address2={isNLAPP ? 'addressLine2' :'address2'}
      countryKey={ isNLAPP ? 'country' : 'countryCode'}
      {...params}
      {...actorDetailsAndActions}
    />
  }
  return (
    <div>
      <div style={{ textAlign: 'center',textTransform:'uppercase' }}>
        {translate('PARTIES', { ns: ['default', 'valueBuildUp'] })}
      </div>
      <div>
        <div>{translate('BUYER', { ns: ['default', 'valueBuildUp'] })}</div>
        {buyers && buyers?.map((buyer) => (
          buyer && <Actor
            actorType='buyer'
            actorName='BUYER'
            boxNumber='1'
            actorDetails={buyer}
            renderForm={actorDetailForm}
          />
        ))}
        <div>{translate('SELLER', { ns: ['default', 'valueBuildUp'] })}</div>
        {sellers && sellers?.map((seller) => (
          seller && <Actor
            actorType='seller'
            actorName='SELLER'
            boxNumber='2'
            actorDetails={seller}
            renderForm={actorDetailForm}
          />
        ))}
      </div>
    </div>
  )
}

export default Parties